const INSTALLATION_KEY = Symbol.for("responder.frameResizeObserver");

export function installFrameResizeObserver(target) {
    if (!target?.ResizeObserver || target[INSTALLATION_KEY]) return false;

    const NativeResizeObserver = target.ResizeObserver;
    const requestFrame = target.requestAnimationFrame?.bind(target) || ((callback) => target.setTimeout(callback, 0));
    const cancelFrame = target.cancelAnimationFrame?.bind(target) || target.clearTimeout?.bind(target);

    class FrameResizeObserver {
        constructor(callback) {
            this.callback = callback;
            this.frame = null;
            this.entries = new Map();
            this.observer = new NativeResizeObserver((entries) => {
                entries.forEach((entry) => this.entries.set(entry.target, entry));
                if (this.frame !== null) return;
                this.frame = requestFrame(() => {
                    this.frame = null;
                    const nextEntries = [...this.entries.values()];
                    this.entries.clear();
                    this.callback(nextEntries, this);
                });
            });
        }

        observe(targetElement, options) {
            this.observer.observe(targetElement, options);
        }

        unobserve(targetElement) {
            this.observer.unobserve(targetElement);
        }

        disconnect() {
            if (this.frame !== null) cancelFrame?.(this.frame);
            this.frame = null;
            this.entries.clear();
            this.observer.disconnect();
        }
    }

    target.ResizeObserver = FrameResizeObserver;
    target[INSTALLATION_KEY] = true;
    return true;
}
